// extracted by mini-css-extract-plugin
export default {"iconFlagBlock":"lan_iconFlagBlock__Izsab"};